<template>
  <div class="assets">
    <!-- <div class="head">
      <span>我的资产</span>
    </div> -->
    <!-- <div class="f-sb top">
      <div class="f-col">
        <span style="color: #7d7d7e; font-size: 13px">Hello,</span>
        <span style="font-size: 15px">{{ nickname }}</span>
      </div>
      <img src="@/assets/images/wallet/notice_read.png" alt="" style="width: 16px; height: 18px" @click="navigation('bulletin', '')" />
    </div> -->
    <div class="">
      <div class="total_box">
        <div class="f-sb">
          <span class="text">用户总资产</span>

          <img src="@/assets/images/wallet/wallet.png" alt="" class="wallet-i" />
        </div>

        <div class="total">
          <span>{{ '$' + Math.floor(assets * 100) / 100 || 0 }}</span>
        </div>
      </div>
      <div class="balance_box">
        <div class="balance_li" @click="navigation('usdtWithdraw', '')">
          <img src="@/assets/images/wallet/w1.png" alt="" class="icon" />
          <span>USDT提现</span>
        </div>
        <!-- <div class="balance_li" @click="navigation('etcManage', '')">
          <img src="@/assets/images/wallet/icon2.png" alt="" class="icon" />
          <span>ETC管理</span>
        </div> -->
        <div class="balance_li" @click="navigation('smhManage', '')">
          <img src="@/assets/images/wallet/w4.png" alt="" class="icon" />
          <span>SMH管理</span>
        </div>
      </div>
      <!-- <div class="balance_box">
        <div class="balance_li" @click="navigation('etcWithdraw', '')">
          <img src="@/assets/images/wallet/icon1.png" alt="" class="icon" />
          <span>ETC提现</span>
        </div>
        <div class="balance_li" @click="navigation('transfer', '')">
          <img src="@/assets/images/wallet/icon2.png" alt="" class="icon" />
          <span>SMH管理</span>
        </div>
      </div> -->

      <div class="bare" v-if="total > 1">
        <span>暂无数据</span>
      </div>
      <div v-else>
        <div class="list">
          <div v-for="(item, index) in coinList" :key="index" class="li" @click="navigation('assetDetails', { coin_type: item.coin_key, coin_name: item.coin_name })">
            <div class="li_left">
              <div class="imgbox">
                <img :src="walletIcon(item.coin_key)" class="li_img" />
              </div>
              <span>{{ item.coin_name }}</span>
            </div>
            <span class="num">{{ Math.floor(item.amount * 100) / 100 || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
    <BottomNavigation></BottomNavigation>
  </div>
</template>

<script>
import BottomNavigation from '@/components/BottomNavigation.vue';
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';

// 扫描 wallet 目录下所有 png，构建 coin_key -> 图标 的映射；
// coin_key 找不到对应图标时统一回退到 usdt，避免动态 require 抛错把整列表带崩
const walletIcons = (() => {
  const map = {}
  try {
    const ctx = require.context('@/assets/images/wallet', false, /\.png$/)
    ctx.keys().forEach(key => {
      const name = key.replace(/^\.\//, '').replace(/\.png$/, '')
      map[name] = ctx(key)
    })
  } catch (e) {
    console.warn('[assets] wallet icons require.context failed', e)
  }
  return map
})()
const FALLBACK_ICON = walletIcons['usdt'] || ''

// 远程图标：key 不在 wallet 本地图标里的就到这里找
const REMOTE_ICONS = {
  jk: 'https://s2.51bqz.com/d/file/coin/5f89aa46ca8b58b232167e3fb681ce18.png',
  jk_power: 'https://s2.51bqz.com/d/file/coin/5f89aa46ca8b58b232167e3fb681ce18.png',
}
export default {
  components: {
    BottomNavigation,
  },
  data() {
    return {
      page: 0,
      loading: false,
      finished: false,
      total: 1,
      nickname: '',
      assets: 0,
      coinList: [
        // {
        //   coin_name: 'USDT',
        //   amount: '0',
        // },
        // {
        //   coin_name: '算力',
        //   amount: '0',
        // },
        // {
        //   coin_name: '能量值',
        //   amount: '0',
        // },
      ],
      showPopover: false,
      typeText: '全部',
      actionType: -1, //-1:全部 0:未知 1:租赁 2:直推奖励 3:团队的算力奖励 4:团队的平级算力奖励
    };
  },
  mounted() {
    this.nickname = JSON.parse(localStorage.getItem('userinfo')).nickname;
    this.actionGet();
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    navigation(name, query) {
      console.log(query);
      if (query.coin_type == 'server') {
        this.$router.push({ name: 'orders' });
      } else if (query.coin_type == 'btc' || query.coin_type == 'filecoin' || query.coin_type == 'tao') {
        return;
      } else {
        this.$router.push({ name, query });
      }
    },
    walletIcon(key) {
      return REMOTE_ICONS[key] || walletIcons[key] || FALLBACK_ICON
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },

    actionGet() {
      homeApi.assets().then(res => {
        if (res.code == 200) {
          this.assets = res.data.assets;
          this.coinList = res.data.coin_list;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.f-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.f-sb-n {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.f-col {
  display: flex;
  flex-direction: column;
}
.assets {
  min-height: 100vh;
  padding: 20px 14px 100px;
  background-color: #fafbfc;
  .top {
    color: #000;
    padding-bottom: 16px;
    margin: 0 6px;
  }
  .total_box {
    // position: relative;
    font-size: 12px;
    color: #fff;
    height: 228px;
    // border-radius: 16px;
    padding: 20px 20px 40px;
    box-sizing: border-box;
    width: 100%;
    background: url('~@/assets/images/wallet/bg.png') no-repeat center;
    background-size: 105% 100%;

    .total {
      font-size: 26px;
      text-align: center;
      padding-top: 50px;
    }
    .text {
      color: rgba(#fff, 0.8);
    }
    .wallet-i {
      width: 26px;
      height: 24px;
      // position: absolute;
      // right: 16px;
      // top: 26px;
    }
  }
  .balance_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    margin: 0 6px;
    border-radius: 20px;
    background-color: #ffffff;
    box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    .balance_li {
      color: #510fa8;
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 48%;
      font-size: 13px;
      border-radius: 16px;
      padding: 16px 0;
      // box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.59);
      // background-color: rgba(255, 255, 255, 0.3);

      .icon {
        width: 20px;
        height: 20px;
        margin-bottom: 10px;
      }
    }
  }

  .bare {
    text-align: center;
    font-size: 14px;
    padding: 60px 14px;
    color: #888;
  }
  .list {
    border-radius: 20px;
    padding: 0 16px;
    margin-top: 16px;
    box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    background-color: #fff;
    margin: 16px 6px;
    .li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      padding: 14px 0;

      .li_left {
        display: flex;
        align-items: center;
        .imgbox {
          width: 40px;
          height: 40px;
          border-radius: 15px;
          background-color: #f1f1f1;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 6px;
        }
        .li_img {
          display: block;
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }
      }

      .num {
        font-size: 16px;
        font-weight: 550;
      }
    }
  }
}
</style>
